import moment from 'moment';

class AcrewardsApiService {
  constructor(HttpService, SessionService) {
    'ngInject';

    this.HttpService = HttpService;
    this.SessionService = SessionService;
  }


  listTurnOverCommission(payload) {
    const queryParams = this.HttpService.buildQueryParamsFromPayload(payload);

    return this.HttpService.get('/' + this.SessionService.getLocale() +  `/acrewards/turnover-commission-list?${queryParams}`);
  }
  
  filterTurnOverCommission(payload) {
    if (payload.dwlDateFrom) {
      payload.dwlDateFrom = moment(payload.dwlDateFrom, 'YYYY-MM-DD').format();
    }

    if (payload.dwlDateTo) {
      payload.dwlDateTo = moment(payload.dwlDateTo, 'YYYY-MM-DD').format();
    }

    const queryParams = this.HttpService.buildQueryParamsFromPayload(payload);
    return this.HttpService.get('/' + this.SessionService.getLocale() +  `/acrewards/turnover-commission-list?${queryParams}`);
  }

  getCurrentRunningCommission() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/acrewards/current-running-commission');
  }

  getPreviousRunningCommission() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/acrewards/previous-running-commission');
  }
}

export default AcrewardsApiService;



// WEBPACK FOOTER //
// ./client/app/api/services/acrewards.api.service.js